import React, {useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import { useAuthState, updateContact, useAuthDispatch } from '../../context';
import Box from '@mui/material/Box';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import HouseIcon from '@mui/icons-material/House';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import Profile from './Profile';
import SetUsernamePassword from './SetUsernamePassword';
import ChangePassword from './ChangePassword';
import UpdateContact from './UpdateContact';
import UpdateAddress from './UpdateAddress';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function AccountPage () {
	const dispatch = useAuthDispatch();
	const user = useAuthState().user;

	const { curSubPage } = useParams();

	useEffect(async () => {
		if (curSubPage === undefined) {
			try {
				await updateContact(dispatch);
			} catch (e) {
				console.error(e);
			}
		}
	}, [curSubPage]);

	const menuItems = [
		{
			name: 'Profile',
			icon: <AccountCircleIcon />,
			visible: true,
			value: undefined,
			component: <Profile user={user}/>
		},
		{
			name: 'Set Password Login',
			icon: <VpnKeyIcon />,
			visible: !user.username,
			value: 'setup',
			component: <SetUsernamePassword />
		},
		{
			name: 'Change Password',
			icon: <VpnKeyIcon />,
			visible: user.username,
			value: 'chpw',
			component: <ChangePassword />
		},
		{
			name: 'Update Email',
			icon: <EmailIcon />,
			visible: true,
			value: 'email',
			component: <UpdateContact method='email' />
		},
		{
			name: 'Update Phone',
			icon: <PermPhoneMsgIcon />,
			visible: true,
			value: 'phone',
			component: <UpdateContact method='text' />
		},
		{
			name: 'Update Address',
			icon: <HouseIcon />,
			visible: true,
			value: 'address',
			component: <UpdateAddress user={user}/>
		}
	]

	const curPageComp = menuItems.find(item => item.value === curSubPage) || menuItems[0];

	return (
		<Box sx={{ display: 'flex' }}>
			{curSubPage &&
				<Box>
					<Button
					component={Link}
					to={'/acc/'}
					variant="default"
				>
						<ArrowBackIcon />
					</Button>
				</Box>
			}
			<Box
				component="main"
				sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
			>
				{curPageComp.component}
			</Box>
		</Box>
	)
}